import React from 'react';
import PropTypes from 'prop-types';

import { breakpoints } from 'app/shared/styles_js/variables';

import { trackAction } from 'app/shared/utils/tracking';

export class GlobalEventHandlers extends React.PureComponent {
  static getCurrentBreakpoint() {
    const width = window.innerWidth;
    const { md, lg, xl } = breakpoints;

    if (width >= md && width < lg) {
      return 'md';
    }
    if (width >= lg && width < xl) {
      return 'lg';
    }
    if (width >= xl) {
      return 'xl';
    }

    return 'sm';
  }

  componentDidMount() {
    const { setBreakpoint } = this.props;
    const breakpoint = GlobalEventHandlers.getCurrentBreakpoint();

    setBreakpoint(breakpoint);
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('beforeprint', this.handlePrint);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('beforeprint', this.handlePrint);
  }

  handlePrint = () => {
    trackAction('user_prints_page', { category: 'printing' });
  };

  handleResize = () => {
    const breakpoint = GlobalEventHandlers.getCurrentBreakpoint();
    const { breakpoint: currentBreakpoint, setBreakpoint } = this.props;

    if (breakpoint !== currentBreakpoint) {
      setBreakpoint(breakpoint);
    }
  };

  render() {
    return false;
  }
}

GlobalEventHandlers.propTypes = {
  setBreakpoint: PropTypes.func.isRequired,
  breakpoint: PropTypes.string,
};

GlobalEventHandlers.defaultProps = {
  breakpoint: 'sm',
};
